// ============================================================================
// JSM CREATE SURVEY
// ============================================================================
import {
	JSM_CREATE_EMBEDDED_REQUEST_KEY,
	JSM_CREATE_REQUEST_KEY,
	JSM_CREATE_REQUEST_V2_KEY,
	JSM_CREATE_SURVEY_KEY,
} from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';
import { JSM_CREATE_SURVEY_CLIENT_ID } from '@atlassian/rovo-content-bridge-api-commands/jsm-create-survey-client';

export const JSM_ACTION_KEYS: string[] = [
	JSM_CREATE_EMBEDDED_REQUEST_KEY,
	JSM_CREATE_REQUEST_KEY,
	JSM_CREATE_REQUEST_V2_KEY,
	JSM_CREATE_SURVEY_KEY,
];

export const JSM_ACTION_KEYS_SET: Set<string> = new Set<string>(JSM_ACTION_KEYS);

export const JSM_CREATABLE_ACTION_KEYS_SET: Set<string> = new Set([JSM_CREATE_SURVEY_KEY]);

export const isJsmAction = (action: unknown): action is MessageAction => {
	return (
		typeof action === 'object' &&
		action !== null &&
		'key' in action &&
		JSM_ACTION_KEYS_SET.has(action?.['key'] as string)
	);
};

export const isJsmCreatableAction = (action: unknown): action is MessageAction =>
	isJsmAction(action) && JSM_CREATABLE_ACTION_KEYS_SET.has(action.key);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isJsmUpdatableAction = (action: { key: string }): boolean => false;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isJsmStreamAction = (action: { key: string }): boolean => false;

export const generateJsmReceiverId = (action: unknown): string | undefined => {
	if (!isJsmAction(action)) {
		return undefined;
	}

	if (isJsmCreatableAction(action)) {
		return JSM_CREATE_SURVEY_CLIENT_ID;
	}

	return undefined;
};

export const getJsmContentType = (action: { key: string }): 'jsm-create-survey' | undefined => {
	const actionKey = action.key;
	if (JSM_CREATABLE_ACTION_KEYS_SET.has(actionKey)) {
		return 'jsm-create-survey';
	}
	return undefined;
};

// ============================================================================
// JSM PREVIEW CARDS
// ============================================================================
const PREVIEW_CARD_ACTION_KEYS = new Set<string>([]);

export const isJsmPreviewCardAction = (action: { key: string }): boolean =>
	PREVIEW_CARD_ACTION_KEYS.has(action.key);
